import { ReactNode } from 'react';

export interface iErrorImage {
  children: ReactNode;
}

function FakeScreen({ children }: iErrorImage) {
  return (
    <div className="relative flex flex-col bg-surface-primary-support max-w-[200px] xs:max-w-[270px] w-full p-4 rounded-2xl text-text-body border-[2px] bg-white">
      <div className="flex justify-start gap-1">
        <div className="size-2.5 rounded-full bg-surface-error"></div>
        <div className="size-2.5 rounded-full bg-surface-warning"></div>
        <div className="size-2.5 rounded-full bg-surface-positive"></div>
      </div>
      <div className="flex-grow self-center my-12">{children}</div>
    </div>
  );
}

export default FakeScreen;
